var React = require('react');

function Number1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.29492 10.78C11.1299 10.78 13.0649 10.42 14.8199 8.665V34H19.6799V2.5H15.1799C13.8749 5.155 11.9849 6.46 8.29492 6.46V10.78Z"}));
}

Number1.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38"};

module.exports = Number1;

Number1.default = Number1;
